import React from 'react';
import './DubaiCalculatorSuccess.css';

const DubaiCalculatorSuccess = () => {
  const spreadsheetUrl = 'https://docs.google.com/spreadsheets/d/12krEkMDB4R71FzDwQDZ_-ICl3z5ZoOtse47MzCKxHpA/edit?usp=sharing';

  return (
    <div className="dubai-success-container">
      <div className="success-content">
        <h2>Success! Find your Dubai Buy vs Rent Calculator Below:</h2>
        
        <div className="calculator-link-section">
          <a 
            href={spreadsheetUrl} 
            target="_blank" 
            rel="noopener noreferrer"
            className="calculator-link"
          >
            {spreadsheetUrl}
          </a>
        </div>

        <div className="instructions-section">
          <h3>Instructions:</h3>
          <ol className="instructions-list">
            <li>
              Click the link - 
              <a 
                href={spreadsheetUrl} 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-link"
              >
                Google Sheets Calculator
              </a>
            </li>
            <li>Click on <strong>File &gt; Make a Copy</strong></li>
            <li><strong>DO NOT ask for edit access, simply make a copy</strong></li>
          </ol>
        </div>

        <div className="cta-section">
          <a 
            href={spreadsheetUrl} 
            target="_blank" 
            rel="noopener noreferrer"
            className="access-calculator-btn"
          >
            Access Calculator Now
          </a>
        </div>
      </div>
    </div>
  );
};

export default DubaiCalculatorSuccess;
